module.exports = __webpack_public_path__ + "static/media/ditto.bf233aea.svg";